<template>
    <div>
        <e-dialog
                dialogTitle="发布新货源"
                :centerDialogVisible="amountTipVisible"
                @updateVisible="resetPopupData"
                @resetPopupData="resetPopupData"
                @submitPopupData="submitPopupData"
                :popupWidth="'400px'"
                :appendToBody="false">
            <div>
                您发布得货源运输总费用：{{totalAmount}}元，<span style="color: #EF4C56">物流费用过高</span>，您确认发布货源吗？
            </div>
        </e-dialog>
    </div>
</template>

<script>
  import eDialog from "../../../components/common/e-dialog";
  export default {
    name: "amountTipDialog",
    components:{eDialog},
    props:{
      amountTipVisible:Boolean,
      totalAmount:Number
    },
    methods:{
      resetPopupData(){
        this.$emit('closeDialog');
      },
      submitPopupData(){
        this.$emit('supplierShip');
      }
    },
  }
</script>

<style scoped lang="scss">

</style>